module.exports = __webpack_public_path__ + "static/media/wbtc.bdfc738e.svg";